import PropTypes from "prop-types";
import Box from "@mui/material/Box";

/**
 * White rounded "card" used inside FormDialog's grey body to group a
 * handful of related fields — matches the chmeetings Add Person/Group/Role
 * modal pattern of small white sections floating on a light-grey background.
 */
function FormSection({ children, sx }) {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 2,
        p: { xs: 2, sm: 2.5 },
        mb: 2,
        "&:last-of-type": { mb: 0 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

FormSection.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

FormSection.defaultProps = {
  children: null,
  sx: {},
};

export default FormSection;
